import { Button } from "../../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { SearchBar } from "../../../components/generic/SearchBar";
import { useState } from "react";
import { UserItem } from "../../../components/users/UserItem";
import AdduserModal from "../../../components/users/AddUsers";
import AddDepartment from "../../../components/users/AddDepartment";
import { useDeptHook } from "../../../hooks/useDeptHook";
import { DepartmentItem } from "../../../components/users/DepartmentIem";
import { NoDepartment } from "./NoDepartment";
import NoDepartmentUsers from "./NoDepartmentUsers";
import UserItemDept from "../../../components/users/UserItemDept";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import AddDepartmentUser from "../../../components/users/AddDepartmentUser";

export default () => {
  const rolepicked = usePickerhook();
  const [entered, setentered] = useState("");
  const { AllOrgDepts , deptUsers} = useDeptHook();
  const users = [1, 2, 3, 4, 5, 6];
  const {selectedDept}=useStateGetter()
  const [showadddept, setshowadddept] = useState(false);

  const onChange = (e: string) => {
    setentered(e);
  };

  return (
    <div className="w-full pr-20  flex  ">
      {showadddept && <AddDepartmentUser show={setshowadddept} />}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            {selectedDept.deptName}
          </p>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add User
              </>
            }
            onBtnClick={() => {
              setshowadddept(true);
            }}
          />
        </div>

        <hr />

        {AllOrgDepts.length > 0 ? (
          <div className="py-4 grid grid-cols-2 gap-4">
            {deptUsers.map((i: any) => (
              <UserItemDept item={i} />
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center">
            <NoDepartmentUsers add={setshowadddept} />
          </div>
        )}
      </div>
    </div>
  );
};
